import React, { useEffect, useState } from 'react'
import NotEligibleFarmTruckView from './components/NotEligibleFarmTruckView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const NotEligibleFarmTruck = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('not-eligible-farm', 'Renew your Vehicle Permit', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <NotEligibleFarmTruckView setIsError={setIsError} />
}

export default withTranslation('common')(NotEligibleFarmTruck)
